import { validate, pledgeValid } from '@/api/api_reserve';
import store from '@/store';

export async function orderValid(bookingList, msg = '잔여석이 남아 있지 않습니다. 다른 날짜나 다른 회차를 선택해주세요.') {
  let bValid = true;
  const validInfo = await validate({ bookingList: bookingList });
  if (validInfo.success) {
    if (validInfo.response.capa?.okYn !== 'Y') {
      alert(msg);
      bValid = false;
    }
  } else {
    alert('오류가 발생하였습니다.');
    bValid = false;
  }

  return bValid;
}

export async function orderPledge(
  bookingList,
  msg = '100명 초과 단체에 대한 가예약 가능 횟수를 2건으로 제한합니다. 예약내역, 예약확인에서 가예약을 확인해주세요.',
) {
  let bValid = true;
  const validInfo = await pledgeValid({ bookingList: bookingList });
  if (validInfo.success) {
    if (validInfo.response.pledge?.okYn !== 'Y') {
      alert(msg);
      bValid = false;
    }
  } else {
    alert('오류가 발생하였습니다.');
    bValid = false;
  }

  return bValid;
}

export function isLoggedIn() {
  if (store.getters.isLoggedIn) {
    return true;
  } else {
    sessionStorage.clear();
    customConfirm('로그인이 필요한 서비스 입니다. 로그인 하시겠습니까?', (confirm) => {
      if (confirm) {
        let domain = process.env.VUE_APP_API_DOMAIN;
        location.href = domain + '/login.do?menuId=109';
      }
    });
    return false;
  }
}

export function toJspPage(url, params) {
  var form = document.createElement('form');
  let domain = process.env.VUE_APP_API_DOMAIN;

  form.setAttribute('charset', 'UTF-8');
  form.setAttribute('method', 'Post'); //Post 방식
  form.setAttribute('action', domain + url); //요청 보낼 주소
  for (let key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
}

/**
 * 확인증 출력 팝업
 * @param bundleRvNo 예약번호
 */
export function openConfirmCardPopup(bundleRvNo) {
  var surl = '/resvr/reserveConfrmCardPopup.do';
  var param = '';

  param = 'bundleRvNo=' + bundleRvNo;
  gfn_popup('/resvr/reserveConfrmCardPopup.do?bundleRvNo=' + bundleRvNo, '650', '780', '체험실예약확인증');
}

export function gfn_popup(strURL, strW, strH, strWinName) {
  var pwidth = strW; // 팝업창 width값
  var pheight = strH; // 팝업창 height값
  var pName; // 팝업창명
  if (strWinName == undefined || strWinName == null) {
    pName = 'popup';
  } else {
    pName = strWinName;
  }

  pwidth = Number(strW) + 5; // 팝업창 width값
  pheight = Number(strH) + 5; // 팝업창 height값

  var sw = screen.availWidth;
  var sh = screen.availHeight;
  var px = (sw - pwidth) / 2;
  var py = (sh - pheight) / 2;

  let domain = process.env.VUE_APP_API_DOMAIN || '';
  var option = 'scrollbars=yes,menubar=no,resizable=no,width=' + pwidth + 'px,height=' + pheight + 'px, top=' + py + ',left=' + px;
  var nw = window.open(domain + strURL, pName, option);
  nw.focus();
}
